<template>
  <div id="app">
    <nav v-if="$route.name !== 'QRCode'">
      <Nav />
    </nav>
    <router-view :class="{ blankPage: isBlankPage }" id="main" />
    <footer v-if="$route.name !== 'QRCode'">
      <Footer />
    </footer>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import DevicePixelRatio from "@/utils/devicePixelRatio";
import ZoomRatio from "@/utils/zoom";

export default {
  components: {
    Nav,
    Footer
  },
  data() {
    return {
      isBlankPage: false,
      copyrightBol: false,
    };
  },
  created() {
    new DevicePixelRatio().init();
    new ZoomRatio().init();
  },
  mounted() {
    if (this.isMobile()) {
      // 只有在不是 /qrcode 路由时才进行重定向
      if (this.$route.name !== 'QRCode') {
        location.href = "https://bbeex-mobile.91act.com/";
      }
    }
  },
  watch: {
    $route(to) {
      this.isBlankPage = to.name === 'QRCode';
    },
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style lang="scss">
//初始化样式，避开浏览器自带样式
body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
fieldset,
legend,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}
body,
button,
input,
select,
textarea {
  font: 12px/1.5tahoma, arial, \5b8b\4f53;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
}
address,
cite,
dfn,
em,
var {
  font-style: normal;
}
code,
kbd,
pre,
samp {
  font-family: sans-serif;
}
small {
  font-size: 12px;
}
ul,
ol {
  list-style: none;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
sup {
  vertical-align: text-top;
}
sub {
  vertical-align: text-bottom;
}
legend {
  color: #000;
}
fieldset,
img {
  border: 0;
}
button,
input,
select,
textarea {
  font-size: 100%;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
@font-face {
  font-family: "MiSans-Bold";
  src: url("./assets/fonts/MiSans-Bold.ttf") format("truetype");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "MiSans-Medium";
  src: url("./assets/fonts/MiSans-Medium.ttf") format("truetype");
  // font-weight: 500;
  font-style: normal;
  font-display: swap;
}
#app {
  width: 1920px;
  height: 983px;
  position: fixed;
  left: 0;
  right: 0;
  //全局字体设置
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
//主要内容样式
#main {
  width: 100%;
  height: calc(100% - 97px);
  position: absolute;
  left: 0;
  top: 97px;
}
.blankPage {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
.blankPage > div {
  width: 100%;
  height: 100%;
}
</style>
